import { createConfigSelector } from '@americanexpress/travel-selectors';

export const getFaasApiUrl = createConfigSelector('faasApiUrl');

export const getLoginUrl = createConfigSelector('loginUrl');

export const getNewDomainUrl = createConfigSelector('newDomainUrl');
